import React, { Fragment } from 'react'
import { connect } from 'react-redux'
import { Route, IndexRoute, Redirect } from 'react-router'
import { getCurrentUser } from 'lib/utils'
import * as favoritesActions from 'lib/api/favorites'
import { SideNavLayout } from 'common/layouts/SideNavLayout'
import { HomepageSideNav } from './HomepageSideNav'
import { DashboardContainer } from '../Dashboard'
import { Calendar } from '../Calendar'
import { RoutesContainer } from '../Routes'
import { RidesContainer } from '../Rides'
import { UserChallenges } from '../Challenges'
import { Collections } from '../Collections'
import { Upload } from '../Upload'
import { FeedContainer } from '../Feed'
import { Analyze } from '../Analyze'

import { MoreContainer } from '../More'

export class DashLayout extends React.PureComponent {
  componentDidMount () {
    // hack to ensure proper display of route/ride pin state.
    // for full discussion, see:
    // https://github.com/ridewithgps/rwgps-ui/pull/1336#discussion_r260435351
    // and the follow-up
    // https://github.com/ridewithgps/ridewithgps/issues/6872
    const { currentUser, loadAllUserFavorites } = this.props
    loadAllUserFavorites(currentUser.id)
  }

  render () {
    const { children, currentUser } = this.props

    return <SideNavLayout
      greyBg
      nav={<HomepageSideNav user={currentUser} />}
      children={children} />
  }
}

const mapStateToProps = state => ({ currentUser: state.currentUser })

const mapDispatchToProps = {
  loadAllUserFavorites: favoritesActions.loadAllUserFavorites
}

const DashLayoutContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(DashLayout)

const AppWrapper = ({ children }) => (
  <DashLayoutContainer>
    {children}
  </DashLayoutContainer>
)

const currentUser = getCurrentUser()
let homePath = (currentUser.preferences && currentUser.preferences['dashboard_home']) || 'dashboard'
if (homePath === 'friends') homePath = 'feed' // TODO remove once preferences['dashboard_home'] migration happens
const routeDefs = [
  ['dashboard', DashboardContainer],
  ['calendar', Calendar],
  ['routes', RoutesContainer],
  ['rides', RidesContainer],
  ['collections', Collections],
  ['analyze', Analyze],
  ['upload', Upload],
  ['feed', FeedContainer],
  ['more', MoreContainer]
]

class HardRedirectToSlash extends React.PureComponent {
  componentDidMount () {
    window.location.href = '/'
  }

  render () {
    return null
  }
}

export const routes = (
  <>
    <Route component={currentUser.id ? AppWrapper : HardRedirectToSlash}>
      {routeDefs.map(([path, component]) => (
        <Fragment key={path}>
          {homePath === path && <IndexRoute component={component} />}
          {homePath === path && <Redirect from={path} to='/' />}
          {homePath !== path && <Route exact path={path} component={component} />}
        </Fragment>
      ))}
    </Route>
    <Route path='/challenges' component={UserChallenges} />
  </>
)
